<template>
    <div>
        <Chart :chart-data="chartData" :options="chartOptions" style="height: 300px" ref="chart" />
    </div>
</template>
<script>
import { addDays } from '@/utils/date'
import { linearAxis, timeAxis } from '@/components/charts/utils'
import Chart from '@/components/charts/chart'

function carryForward(data) {
    const now = new Date()
    const last = data[data.length - 1]
    const year = addDays(365, last.x)
    const threshold = addDays(540, last.x)

    if (threshold < now) {
        data.push({ x: year, y: 0 })
    } else {
        data.push({ x: year < now ? next : now, y: last.y })
    }
}

export default {
    components: {
        Chart,
    },
    props: {
        rows: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
    },
    computed: {
        chartData() {
            return {
                datasets: [this.outstanding, this.owned].filter(ds => ds !== null),
            }
        },
        chartOptions() {
            return {
                tooltips: {
                    enabled: false,
                    mode: 'x',
                    position: 'nearest',
                },
                layout: {
                    padding: {
                        left: 16,
                        right: 16,
                        top: 0,
                        bottom: 0,
                    },
                },
                animation: {
                    duration: 0,
                },
                legend: {
                    display: true,
                },
                scales: {
                    xAxes: [this.xAxis],
                    yAxes: [this.yAxis],
                },
                datasets: {
                    line: {
                        pointRadius: 0,
                        spanGaps: true,
                        borderCapStyle: 'round',
                        borderJoinStyle: 'round',
                        lineTension: 0,
                        bezierCurve: false,
                        fill: 'start',
                    },
                    bubble: {
                        borderColor: 'white',
                    },
                },
            }
        },
        outstanding() {
            if (this.sorted.find(dp => dp.pledgedOfOutstanding !== null)) {
                const dataset = {
                    type: 'line',
                    label: '% of Outstanding Pledged',
                    data: this.sorted.map(dp => ({ x: new Date(dp.effectiveDate), y: dp.pledgedOfOutstanding * 100 })),
                    backgroundColor: 'rgb(250, 244, 236)',
                    borderColor: 'rgb(225, 192, 147,1)',
                }

                carryForward(dataset.data)

                return dataset
            }

            return null
        },
        owned() {
            const dataset = {
                type: 'line',
                label: '% of Owned Pledged',
                data: this.sorted.map(dp => ({ x: new Date(dp.effectiveDate), y: dp.pledgedOfOwned * 100 })),
                backgroundColor: 'rgb(225, 246, 251)',
                borderColor: 'rgb(0, 202, 234)',
            }

            carryForward(dataset.data)

            return dataset
        },
        sorted() {
            return this.rows.slice(0).sort((lhs, rhs) => lhs.effectiveDate.localeCompare(rhs.effectiveDate))
        },
        xAxis() {
            const min = addDays(-90, this.owned.data[0].x)
            const max = addDays(90)

            return timeAxis(min, max)
        },
        yAxis() {
            const axis = linearAxis(0, 100)
            axis.ticks.callback = n => `${n}%`
            return axis
        },
    },
}
</script>
